export const TEST_ID = 'airplaneIcon';
